function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Clone");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "square"
}, React.createElement("g", {
  id: "sa-landing",
  transform: "translate(-617.000000, -16.000000)",
  stroke: "#979797"
}, React.createElement("g", {
  id: "Group-27"
}, React.createElement("g", {
  id: "clone",
  transform: "translate(618.000000, 17.000000)"
}, React.createElement("g", {
  id: "copy"
}, React.createElement("rect", {
  id: "Rectangle",
  x: 3,
  y: 3,
  width: 9,
  height: 10
}), React.createElement("polyline", {
  id: "Path",
  points: "8.46940415 0 0 0 0 9.53591028"
}))))));

var SvgClone = function SvgClone(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "14px",
    height: "15px",
    viewBox: "0 0 14 15",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgClone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clone.06098a84.svg";
export { ForwardRef as ReactComponent };